import React, { useState } from "react";
import axios from "axios";
import { Button } from "../../components/ui/button";
import { toast } from "react-toastify";

import InputField from "../../components/ui/InputField";
import TextAreaField from "../../components/ui/TextAreaField";

const MovimientoExternoForm = ({ equipoId, onClose, onSaved }) => {
  const [destino, setDestino] = useState("");
  const [responsable, setResponsable] = useState("");
  const [contacto, setContacto] = useState("");
  const [responsableEquipo, setResponsableEquipo] = useState("");
  const [observacion, setObservacion] = useState("");
  const [loading, setLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  const submit = async () => {
    if (!destino.trim()) {
      toast.warning("El destino es obligatorio");
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        `${API}/movimientos/externo/${equipoId}`,
        {
          destino,
          responsable,
          contacto,
          responsableEquipo,
          observacion,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      toast.success("Movimiento externo registrado");
      onSaved();
      onClose();
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Error al registrar movimiento externo",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <InputField
        label="Destino *"
        value={destino}
        onChange={(e) => setDestino(e.target.value)}
        placeholder="Ej: Taller biomédico externo, Proveedor XYZ"
      />

      <InputField
        label="Responsable externo"
        value={responsable}
        onChange={(e) => setResponsable(e.target.value)}
        placeholder="Nombre de quien recibe el equipo"
      />

      <InputField
        label="Contacto"
        value={contacto}
        onChange={(e) => setContacto(e.target.value)}
        placeholder="Teléfono, correo, WhatsApp…"
      />

      <InputField
        label="Responsable del equipo (opcional)"
        value={responsableEquipo}
        onChange={(e) => setResponsableEquipo(e.target.value)}
        placeholder="Ej: Ing. Biomédico, Técnico asignado"
      />

      <TextAreaField
        label="Observación"
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
        placeholder="Motivo del traslado, condición del equipo, etc."
        rows={3}
      />

      <div className="flex justify-end gap-3 pt-2">
        <Button variant="outline" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={submit} disabled={loading}>
          {loading ? "Registrando..." : "Registrar movimiento"}
        </Button>
      </div>
    </div>
  );
};

export default MovimientoExternoForm;
